import Link from "next/link";
import { Layout } from "../components/layout/layout.comp";
import { LongCopy } from "../components/longCopy/longCopy.comp";

export default function TermsPage() {
  return (
    <Layout
      showHeader={true}
      showFooter={true}
      title="Terms & Conditions"
      url="https://www.bracketsninja.com/terms"
    >
      <LongCopy title="Terms & Conditions">
        <h5 className="heading-5">1. Terms</h5>
        <p>
          By accessing this website, you are agreeing to be bound by these
          website Terms and Conditions of Use, our{" "}
          <Link href="/privacy">Privacy Policy</Link> which is available here,
          all applicable laws and regulations, and agree that you are
          responsible for compliance with any applicable local laws. If you do
          not agree with any of these terms, you are prohibited from using or
          accessing this site. The materials contained in this website are
          protected by applicable copyright and trade mark law.
        </p>

        <h5 className="heading-5">2. Use License</h5>
        <p>
          Permission is granted to temporarily download one copy of the
          materials (information or software) on Common {`Ninja's`} website for
          personal, non-commercial transitory viewing only. This is the grant of
          a license, not a transfer of title, and under this license you may
          not:
        </p>

        <ol className="order">
          <li>Modify or copy the materials.</li>
          <li>
            Use the materials for any commercial purpose, or for any public
            display (commercial or non-commercial).
          </li>
          <li>
            Attempt to decompile or reverse engineer any software contained on
            Common {`Ninja's`} website.
          </li>
          <li>
            Remove any copyright or other proprietary notations from the
            materials. or
          </li>
          <li>
            Transfer the materials to another person or {`"mirror"`} the
            materials on any other server.
          </li>
        </ol>

        <p>
          This license shall automatically terminate if you violate any of these
          restrictions and may be terminated by Common Ninja at any time. Upon
          terminating your viewing of these materials or upon the termination of
          this license, you must destroy any downloaded materials in your
          possession whether in electronic or printed format.
        </p>

        <h5 className="heading-5">3. Disclaimer</h5>
        <p>
          The materials on Common {`Ninja's`} website are provided {`"as is"`}.
          Common Ninja makes no warranties, expressed or implied, and hereby
          disclaims and negates all other warranties, including without
          limitation, implied warranties or conditions of merchantability,
          fitness for a particular purpose, or non-infringement of intellectual
          property or other violation of rights. Further, Common Ninja does not
          warrant or make any representations concerning the accuracy, likely
          results, or reliability of the use of the materials on its Internet
          website or otherwise relating to such materials or on any sites linked
          to this site.
        </p>

        <h5 className="heading-5">4. Limitations</h5>
        <p>
          In no event shall Common Ninja or its suppliers be liable for any
          damages (including, without limitation, damages for loss of data or
          profit, or due to business interruption,) arising out of the use or
          inability to use the materials on Common {`Ninja's`} Internet site,
          even if Common Ninja or a Common Ninja authorized representative has
          been notified orally or in writing of the possibility of such damage.
          Because some jurisdictions do not allow limitations on implied
          warranties, or limitations of liability for consequential or
          incidental damages, these limitations may not apply to you.
        </p>

        <h5 className="heading-5">5. Revisions and Errata</h5>
        <p>
          The materials appearing on Common {`Ninja's`} website could include
          technical, typographical, or photographic errors. Common Ninja does
          not warrant that any of the materials on its website are accurate,
          complete, or current. Common Ninja may make changes to the materials
          contained on its website at any time without notice. Common Ninja does
          not, however, make any commitment to update the materials.
        </p>

        <h5 className="heading-5">6. Links</h5>
        <p>
          Common Ninja has not reviewed all of the sites linked to its Internet
          website and is not responsible for the contents of any such linked
          site. The inclusion of any link does not imply endorsement by Common
          Ninja of the site. Use of any such linked website is at the {`user's`}{" "}
          own risk.
        </p>

        <h5 className="heading-5">7. Site Terms of Use Modifications</h5>
        <p>
          Common Ninja may revise these terms of use for its website at any time
          without notice. By using this website you are agreeing to be bound by
          the then current version of these Terms and Conditions of Use.
        </p>

        <h5 className="heading-5">8. Governing Law</h5>
        <p>
          Any claim relating to Common {`Ninja's`} website shall be governed by
          the laws of the State of Israel without regard to its conflict of law
          provisions.
        </p>
        <h5 className="heading-5">9. Data Processing Addendum</h5>
        <p>
          Our Data Processing Addendum, which can be found{" "}
          <Link href="/privacy/dpa">here</Link>, forms an integral part of these
          Terms and Conditions. By using our Common Ninja Developer Platform,
          you agree to the terms of our Data Processing Addendum. For any
          questions, contact us at privacy@commoninja.com.
        </p>
        <h5 className="heading-5">10. Use of Customer Logos</h5>
        <p>
          By using Common {`Ninja's`} services, you grant Common Ninja the right to
          use your {`company's`} logo in our marketing materials and on our website
          under the section titled {`"Trusted by"`}. This includes the right for
          Common Ninja to display your logo as an indication of your use and
          endorsement of our services. Selected {`customers'`} logos will be used
          solely for this purpose and in a manner that maintains the integrity
          and reputation of your brand.
        </p>

        <p>General Terms and Conditions applicable to use of a website.</p>
      </LongCopy>
    </Layout>
  );
}
